






































/**
 * btnData
 */
interface BtnData {
  /** 跳转路径 */
  url: string;
  /** id */
  id: number;
  /** sourceId */
  informationId: number;
  /** 详情页打开方式：{1:图文新闻,2:普通新闻,3:专题新闻,4:随手拍,5:段子,7:话题,8:纯webView展示(无导航栏和底部评论),9:带有系统导航栏的webView,10:旅游详情,11:旅游专题详情,98:新版特殊webview,99:特殊webview} */
  detailViewType: number;
  /** (非空)来源类型：{1:新闻,2:问政,3:商情,4:随手拍,5:段子,6:活动,7:话题,8:便民,9:热线,10:旅游,11:置业,12:招聘}' */
  sourceType: number;
  /** 评论：0允许，1不允许 */
  commentType: number;
  /** contextType */
  contextType: number;
  /** (有分享功能的话非空)分享url */
  shareUrl: string;
  /** (有分享功能的话非空)分享标题(base64编码) */
  title: string;
  /** 分享简介(base64编码) */
  synopsis: string;
  /** (有分享功能的话非空)分享图片 */
  shareImgUrl: string;
}
import { Component, Vue } from "vue-property-decorator";
import Base64 from "@/common/base64.ts";
@Component
export default class Ddh extends Vue {
  btnData: BtnData[] = [
    {
      url:
        "https://share.cqliving.com/news-detail-pages/#/special/special-page?appId=4&cid=66312862&vfrom=cms",
      id: 66312862,
      informationId: 5915725,
      detailViewType: 98,
      sourceType: 1,
      commentType: 1,
      contextType: 6,
      shareUrl:
        "https://share.cqliving.com/news-detail-pages/#/special/special-page?appId=4&cid=66312862&vfrom=cms",
      title: "议程日程",
      synopsis: "",
      shareImgUrl: "https://imagecdn.cqliving.com/images/icon/4.png"
    },
    {
      url:
        "https://share.cqliving.com/news-detail-pages/#/special/special-page?appId=4&cid=66314383&vfrom=cms",
      id: 66314383,
      informationId: 5915730,
      detailViewType: 98,
      sourceType: 1,
      commentType: 1,
      contextType: 6,
      shareUrl:
        "https://share.cqliving.com/news-detail-pages/#/special/special-page?appId=4&cid=66314383&vfrom=cms",
      title: "座位安排",
      synopsis: "",
      shareImgUrl: "https://imagecdn.cqliving.com/images/icon/4.png"
    },
    {
      url:
        "https://share.cqliving.com/news-detail-pages/#/special/special-page?appId=4&cid=66315281&vfrom=cms",
      id: 66315281,
      informationId: 5915739,
      detailViewType: 98,
      sourceType: 1,
      commentType: 1,
      contextType: 6,
      shareUrl:
        "https://share.cqliving.com/news-detail-pages/#/special/special-page?appId=4&cid=66315281&vfrom=cms",
      title: "工作报告",
      synopsis: "",
      shareImgUrl: "https://imagecdn.cqliving.com/images/icon/4.png"
    },
    {
      url:
        "https://share.cqliving.com/news-detail-pages/?isOpenApp=1#/special/special-page?appId=4&cid=66315471&vfrom=cms",
      id: 66315471,
      informationId: 5915742,
      detailViewType: 98,
      sourceType: 1,
      commentType: 1,
      contextType: 6,
      shareUrl:
        "https://share.cqliving.com/news-detail-pages/?isOpenApp=1#/special/special-page?appId=4&cid=66315471&vfrom=cms",
      title: "成果展示",
      synopsis: "",
      shareImgUrl: "https://imagecdn.cqliving.com/images/icon/4.png"
    }
  ];

  mounted(): void {
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "中国共产党重庆市南岸区第十三次代表大会",
        isShowMoreBtn: "0"
      });
    } else {
      document.title = "中国共产党重庆市南岸区第十三次代表大会";
    }
  }

  /** 跳转外部链接 */
  link(index: number) {
    if (ZWY_CLOUD.isOpenInApp()) {
      try {
        ZWY_CLOUD.redirectUrl({
          id: this.btnData[index].id,
          sourceId: this.btnData[index].informationId + "",
          detailViewType: this.btnData[index].detailViewType + "",
          sourceType: this.btnData[index].sourceType + "",
          commentType: this.btnData[index].commentType + "",
          contextType: this.btnData[index].contextType + "",
          url: this.btnData[index].url,
          shareUrl: this.btnData[index].shareUrl,
          title: Base64.encode(this.btnData[index].title), // 标题(base64编码)
          synopsis: Base64.encode(this.btnData[index].synopsis), // 简介(base64编码)
          shareImgUrl: this.btnData[index].shareImgUrl,
          isShowTop: "1",
          isShowBottom: index === 3 ? "1" : "0",
          isShowMore: "0"
        });
      } catch (e) {
        window.location.href = this.btnData[index].url;
      }
    } else {
      window.location.href = this.btnData[index].url;
    }
  }
}
